import React, { useState, useEffect } from "react";
import Clock from "../components/Clock";
import Footer from "../components/footer";
import { createGlobalStyle } from "styled-components";
import { useParams } from "@reach/router";
import axios from "axios";
import { bnToNum } from "../../utilities/bigNumbers";

import { useContractContext } from "../../hooks/useContractContext";

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #FAF6F1;
    border-bottom: solid 1px #ccc !important;
  }
`;

const formatIpfsUrl = (url) => {
  return url.replace(/ipfs:\/\//g, "https://nftstorage.link/");
};

const Colection = function () {
  const [openMenu, setOpenMenu] = React.useState(true);
  const [openMenu1, setOpenMenu1] = React.useState(false);
  const handleBtnClick = () => {
    setOpenMenu(!openMenu);
    setOpenMenu1(false);
    document.getElementById("Mainbtn").classList.add("active");
    document.getElementById("Mainbtn1").classList.remove("active");
  };
  const handleBtnClick1 = () => {
    setOpenMenu1(!openMenu1);
    setOpenMenu(false);
    document.getElementById("Mainbtn1").classList.add("active");
    document.getElementById("Mainbtn").classList.remove("active");
  };

  const { copyrightsContract, licensesContract } = useContractContext();

  const params = useParams();
  const licenseTokenId = params.licenseTokenId;

  const [copyrightsDetailsOfWork, setCopyrightsDetailsOfWork] = useState({
    creatorPseudonym: "",
    workFormat: "",
    yearCreated: "",
    workIpfsCid: "",
  });
  const [copyrightsMetaData, setCopyrightsMetaData] = useState();
  const [licenseContractRef, setlicenseContractRef] = useState({
    copyrightOwner: "",
    artworkAddr: "",
    artworkId: null,
    duration_days: "",
    amountPaid: null,
  });
  const [licenseMetaData, setLicenseMetaData] = useState({
    imageCID: "",
    licenseAgreement: {
      Title: "",
      Owner: "",
      Receiver: "",
      Start_Date: "",
      Termination_Date: "",
      Duration_Days: "",
      Purpose: "",
      Grant_Of_License: "",
      Rights_and_Obligations: "",
      Payment_Of_Royalty: "",
      Modifications: "",
      Deafults: "",
      Arbitration: "",
      Warranties: "",
      Transfer_Of_Rights: "",
      Indemnification: "",
      Termination: "",
      Entire_Agreement: "",
      Amendment: "",
      Severability: "",
      Notice: "",
      Applicable_Law: "",
      Signatories: "",
    },
  });
  const [ETHSGD, setETHSGD] = useState();

  useEffect(() => {
    const fetchData = async () => {
      var licenseURI = formatIpfsUrl(
        await licensesContract.tokenURI(licenseTokenId)
      );
      var _licenseContractRef = await licensesContract.checkLicenseReference(
        licenseTokenId
      );
      setlicenseContractRef(_licenseContractRef);
      var _licenseMetaData = (await axios.get(licenseURI)).data;
      setLicenseMetaData(_licenseMetaData);
      setETHSGD(
        (
          await axios.get(
            "https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=SGD"
          )
        ).data.SGD
      );

      var tokenId = await _licenseContractRef.artworkId.toNumber();

      setCopyrightsDetailsOfWork(
        await copyrightsContract.checkDetailsOfWork(tokenId)
      );

      var ipfsUri = await copyrightsContract.tokenURI(tokenId);
      var formattedUri = formatIpfsUrl(ipfsUri);
      setCopyrightsMetaData((await axios.get(formattedUri)).data);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <GlobalStyles />

      <section className="container">
        <div className="row mt-md-5 pt-md-4">
          <div className="col-md-3 text-center">
            <img
              src={formatIpfsUrl(licenseMetaData.imageCID)}
              className="img-fluid img-rounded mb-sm-30"
              alt=""
            />
            {licenseMetaData.imageCID && (
              <a href={formatIpfsUrl(licenseMetaData.imageCID)}>
                Download image from here
              </a>
            )}
          </div>
          <div className="col-md-9">
            <div className="item_info">
              License ends in
              <div className="de_countdown">
                {licenseMetaData.licenseAgreement.Termination_Date && (
                  <Clock
                    deadline={licenseMetaData.licenseAgreement.Termination_Date.toString()}
                  />
                )}
              </div>
              <h2>
                {copyrightsMetaData === undefined
                  ? ""
                  : copyrightsMetaData.title}
              </h2>
              <div className="item_info_counts">
                <div className="item_info_type">
                  <i className="fa fa-image"></i>Art
                </div>
              </div>
              <p>
                {copyrightsMetaData === undefined
                  ? "loading..."
                  : copyrightsMetaData.description}
              </p>
              <h6>Creator</h6>
              <div className="item_author">
                <span>{copyrightsDetailsOfWork.creatorPseudonym}</span>
              </div>
              <div className="spacer-40"></div>
              <div className="de_tab">
                <ul className="de_nav">
                  <li id="Mainbtn" className="active">
                    <span onClick={handleBtnClick}>Artwork</span>
                  </li>
                  <li id="Mainbtn1" className="">
                    <span onClick={handleBtnClick1}>
                      Agreement Illustration
                    </span>
                  </li>
                </ul>

                <div className="de_tab_content">
                  {openMenu && (
                    <div className="tab-1 onStep fadeIn">
                      <div>
                        <h4>Copyright Owner</h4>
                        <p>{licenseContractRef.copyrightOwner}</p>
                      </div>
                      <div>
                        <h4>Artwork Address</h4>
                        <p>{licenseContractRef.artworkAddr}</p>
                      </div>
                      <div>
                        <h4>Artwork TokenId</h4>
                        <p>
                          {licenseContractRef.artworkId !== null &&
                            licenseContractRef.artworkId.toNumber()}
                        </p>
                      </div>
                      <div>
                        <h4>License Duration (Days)</h4>
                        <p>{licenseContractRef.duration_days}</p>
                      </div>
                      <div>
                        <h4>License Fee (Paid)</h4>
                        {ETHSGD !== "" &&
                          licenseContractRef.amountPaid !== null && (
                            <p>
                              {bnToNum(licenseContractRef.amountPaid, 18, 5)}{" "}
                              ETH (
                              {(
                                bnToNum(licenseContractRef.amountPaid, 18, 5) *
                                ETHSGD
                              ).toFixed(2)}{" "}
                              SGD)
                            </p>
                          )}
                      </div>
                    </div>
                  )}
                </div>

                <div className="de_tab_content">
                  {openMenu1 && (
                    <div className="col-md-9 mt-3">
                      {Object.entries(licenseMetaData.licenseAgreement).map(
                        (array) => (
                          <div>
                            <h4>{array[0]}</h4>
                            <p>{array[1]}</p>
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
export default Colection;
